import { render, staticRenderFns } from "./CollegeMapDashboard.vue?vue&type=template&id=81df7818&scoped=true&"
import script from "./CollegeMapDashboard.vue?vue&type=script&lang=js&"
export * from "./CollegeMapDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CollegeMapDashboard.vue?vue&type=style&index=0&id=81df7818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81df7818",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
